import React, { useEffect, useRef, useState } from "react";
import "./workspace-documents.component.scoped.scss";
import { Box, Button, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { icons } from "../../../../../statics/icons";
import { fileTypes } from "../../../../../statics/file-types";
import { validateFiles } from "../../../../../helpers/validate-file";
import { DocumentNameDialog } from "../../../../../dialogs/document-name/document-name-dialog";
import { DocumentsService } from "../../../../../services/documents.services";
import {
  formatDate,
  showPopupToastMsg,
  showToastMsg,
} from "../../../../../helpers";

const WorkspaceDocumentsComponent = () => {
  const { t } = useTranslation();
  const documentsService = new DocumentsService();
  const [saving, setSaving] = useState(false);
  const [documents, setDocuments] = useState<any>([]);
  const [file, setFile] = useState<any>();
  const [showDocumentNameModal, setShowDocumentNameModal] = useState(false);
  //   const [showConfirmModal, setShowConfirmModal] = useState(false);

  const inputFileRef = useRef(null);

  const fetchDocuments = async () => {
    setSaving(true);
    const response = await documentsService.list();
    setDocuments(response.data);
    setSaving(false);
  };

  const clickUpload = () => {
    if (!saving) {
      const element: any = inputFileRef.current;
      element.click();
    }
  };

  const onFileChange = async (e: any) => {
    await onValidateFile(e.target.files);
    const element: any = inputFileRef.current;
    element.value = "";
  };

  const onValidateFile = async (files: any) => {
    const filteredFiles = await validateFiles(files, fileTypes);
    setFile(filteredFiles[0]);
    setShowDocumentNameModal(true);
  };

  const handleClose = (value: any) => {
    if (value) {
      addDocument(value);
    }
    setShowDocumentNameModal(false);
  };

  const addDocument = async (file: any) => {
    const response = await documentsService.add(file);
    setDocuments((prev: any) => [response.document, ...prev]);
    if (response.message === "SUCCESS") {
      showToastMsg("success", t("DOCUMENT_ADDED_SUCCESSFULLY"));
    } else {
      showPopupToastMsg("error", t("SOME_THING_WENT_WRONG"));
    }
  };

  const downloadFile = (url: string) => {
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  const deleteDocument = async (id: number) => {
    const response = await documentsService.delete(id);
    if (response.message === "SUCCESS") {
      showToastMsg("success", t("DOCUMENT_DELETED_SUCCESSFULLY"));
      setDocuments((prev: any) =>
        prev.filter((document: any) => document.id !== id),
      );
    } else {
      showPopupToastMsg("error", t("SOME_THING_WENT_WRONG"));
    }
  };

  useEffect(() => {
    fetchDocuments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className="global__box__content mb-4 p-0">
      <Box className="title">
        <Typography variant="h3" style={{ fontWeight: 400 }}>
          {t("COMPANY_RELEVANT_DOCUAMNTS")}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          className="btn-primary-theme"
          size="small"
          onClick={clickUpload}
        >
          {t("UPLOAD_DOCUMENT")}
        </Button>
        <input
          type="file"
          ref={inputFileRef}
          onChange={onFileChange}
          style={{ display: "none" }}
          accept={fileTypes}
          disabled={saving}
        />
      </Box>
      <Box className="content">
        {!documents.length && (
          <Box className="text-center my-4">
            <Box className="drop-img">
              <img src={icons.DROP_FILE} alt="" />
            </Box>
            <Typography variant="h4">
              {t("CLICK_TO_UPLOAD_YOUR_FILE")}
            </Typography>
            <Typography variant="subtitle2">
              {t("ADD_FILE_AND_GIVE_NAME")}
            </Typography>
          </Box>
        )}
        {documents.map((document: any, index: number) => {
          return (
            <Box
              className="item d-flex align-items-center justify-content-between mb-3"
              key={index}
            >
              <Box
                className="d-flex align-items-center"
                style={{ gap: "1rem" }}
              >
                <img src={icons.DOCUMENT} alt="DOCUMENT" />
                <Box className="info">
                  <Box
                    className="d-flex align-items-center mb-1"
                    style={{ gap: ".5rem" }}
                  >
                    <Typography variant="subtitle2" style={{ fontWeight: 500 }}>
                      {document.name}
                    </Typography>
                    <span className="date">
                      {t("UPLOADED_ON")}{" "}
                      {formatDate(document.createdAt, "DD.MM.YYYY")}
                    </span>
                  </Box>
                  <Typography variant="body1">
                    {t("UPLOADED_BY")} {document.userEmail}
                  </Typography>
                  <Typography variant="body1">
                    {t("FILE_NAME")}: {document.file}
                  </Typography>
                </Box>
              </Box>
              <Box className="actions">
                <Button
                  variant="contained"
                  color="secondary"
                  style={{
                    color: "#fff",
                    background: "var(--secondary)",
                    fontSize: "1rem",
                    fontWeight: 300,
                    textTransform: "capitalize",
                  }}
                  className="mr-2"
                  size="small"
                  onClick={() => downloadFile(document.url)}
                >
                  {t("DOWNLOAD")}
                </Button>
                <Button
                  variant="text"
                  style={{
                    textDecoration: "underline",
                    color: "var(--secondary)",
                    fontSize: "1rem",
                    fontWeight: 300,
                    textTransform: "capitalize",
                  }}
                  onClick={() => deleteDocument(document.id)}
                  size="small"
                >
                  {t("DELETE")}
                </Button>
              </Box>
            </Box>
          );
        })}
      </Box>

      {/* {showConfirmModal && (
        <ConfirmDialog
          show={showConfirmModal}
          onClose={handleDeleteDocument}
          dialogTitle={t("confirm delete")}
          dialogBody={t("Are you sure you want to delete the document")}
          confirmBtnText={t("delete")}
          cancelBtn={true}
        />
      )} */}
      {showDocumentNameModal && file && (
        <DocumentNameDialog
          file={file}
          path="documents"
          show={showDocumentNameModal}
          onClose={handleClose}
        />
      )}
    </Box>
  );
};
export default WorkspaceDocumentsComponent;
